import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';

const How3 = ({
  background, title, subtitle1, subtitle2, subtitle3, contentHtml1, contentHtml2, contentHtml3,
  ctaHtml
}) => (
  <section className={classnames("block block-how-3", background)}>
    <div className="row columns">
      <div className="block-header">
        <h2>{ title || "How does crowdspring work?" }</h2>
      </div>
    </div>
    <div className="row small-up-1 large-up-3">
      <div className="columns text-center">
        <h3>{ subtitle1 || "Tell us what you need" }</h3>
        { contentHtml1?
        <div dangerouslySetInnerHTML={{ __html: contentHtml1 }} /> :
        <p>
          <Link to="/categories/">Choose from 30+ categories</Link>, complete
          a project brief, and pick a package that fits your budget.
        </p> }
      </div>
      <div className="columns text-center">
        <h3>{ subtitle2 || "Creatives submit designs" }</h3>
        { contentHtml2?
        <div dangerouslySetInnerHTML={{ __html: contentHtml2 }} /> :
        <p>
          <Link to="/how-it-works/">Collaborate with dozens of creatives</Link>, give
          feedback and score, and get revised custom designs.
        </p> }
      </div>
      <div className="columns text-center">
        <h3>{ subtitle3 || "Choose your favorite" }</h3>
        { contentHtml3?
        <div dangerouslySetInnerHTML={{ __html: contentHtml3 }} /> :
        <p>
          Work with the winner to finalize your favorite design and get print/web-ready files and full IP rights.
        </p> }
      </div>
    </div>
    <div className="row columns text-center cta">
      { ctaHtml?
      <div dangerouslySetInnerHTML={{ __html: ctaHtml }} /> :
      <div>
        Not into crowds?<br/>
        Pick a creative and <Link to="/start-a-project/start-1-1/">work 1-on-1</Link>.
      </div> }
    </div>
  </section>
);

How3.propTypes = {
  background: PropTypes.string,
  title: PropTypes.string,
  subtitle1: PropTypes.string,
  contentHtml1: PropTypes.string,
  subtitle2: PropTypes.string,
  contentHtml2: PropTypes.string,
  subtitle3: PropTypes.string,
  contentHtml3: PropTypes.string,
  ctaHtml: PropTypes.string,
};

export default How3;



// WEBPACK FOOTER //
// ./landing_pages/components/how_3.jsx